export enum Roles {
  admin = 'Administrator',
  dataAnalyst = 'Data Analyst',
  staff = 'Staff',              // lowest accessibiity 
}

export default Roles;  